import { STORAGE, useLocalStorageStore } from '@/store';

export const hasShownLimitModal = () => {
  return useLocalStorageStore.getState().get(STORAGE.HAS_SHOWN_LIMIT_MODAL);
};
